// extracted by mini-css-extract-plugin
export default {"sliderArrow":"MultipleSlider_sliderArrow__MUCz8","prevArrow":"MultipleSlider_prevArrow__cBcNH"};